import React from 'react';

import _ from 'lodash';
import classnames from 'classnames';
import Skeleton from 'react-loading-skeleton';

import { INFLUENCER_PREVIEW_URL } from 'global-constants';
import ExternalLink from 'shared/components/ExternalLink';
import { substituteUrl } from 'shared/utils/substituteUrl';
import { getImageStyle } from 'shared/utils/getImageStyle';
import {
  getInfluencerFullName,
  getInfluencerOccupation
} from 'shared/utils/influencer';
import ConnectButton from 'shared/components/ConnectButton';
import MessageButton from 'shared/components/MessageButton';

import defaultAvatar from 'assets/images/default-avatar.png';

import styles from './styles.module.scss';

const Placeholder = ({ count = 1, className }) =>
  _.range(count).map(id => (
    <div
      key={`influencer-line-placeholder-${id}`}
      className={classnames(
        styles.influencerBox,
        styles.placeholder,
        className
      )}>
      <div className={classnames(styles.avatar, styles.withShadow)}>
        <Skeleton height={85} width={85} />
      </div>
      <div>
        <div className={styles.name}>
          <Skeleton width={150} />
        </div>
        <div className={styles.occupation}>
          <Skeleton width={100} />
        </div>
      </div>
    </div>
  ));

let InfluencerLine = ({
  influencer,
  isSameUser,
  handleMessageUnsignedClick,
  className,
  withImageShadow = true,
  messageButtonAdditionalActions = [],
  showVendorInInfluencerOccupation = true
}) => {
  const detailUrl = substituteUrl(INFLUENCER_PREVIEW_URL, {
    influencerSlug: influencer.slug
  });

  const occupation = getInfluencerOccupation(
    influencer,
    ' | ',
    showVendorInInfluencerOccupation
  );
  return (
    <div className={classnames(styles.influencerBox, className)}>
      <ExternalLink href={detailUrl}>
        <div
          className={classnames(styles.avatar, styles.pointer, {
            [styles.withShadow]: withImageShadow
          })}
          style={getImageStyle({
            image: influencer.profile.avatar,
            thumbnails: influencer.profile.thumbnails,
            height: 85,
            width: 85,
            defaultImage: defaultAvatar,
            backgroundSize: 'contain'
          })}
        />
      </ExternalLink>
      <div>
        <ExternalLink
          className={classnames(styles.name, styles.pointer)}
          href={detailUrl}>
          {getInfluencerFullName(influencer)}
        </ExternalLink>
        <div className={styles.occupation}>{occupation}</div>
        <div className={styles.links}>
          {!isSameUser && (
            <React.Fragment>
              <MessageButton
                handleUnsigned={handleMessageUnsignedClick}
                target={influencer}
                buttonAdditionalActions={messageButtonAdditionalActions}
              />
              <ConnectButton
                className={styles.connect}
                influencer={influencer}
                connected={influencer.connected}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

InfluencerLine.Placeholder = Placeholder;
export default InfluencerLine;
